import { Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, FormGroup, Grid, IconButton } from '@mui/material'
import React, { useEffect, useState } from 'react'
import DashboardContainer from '../../components/DashboardContainer';
import PageContainer from '../../components/PageContainer'
import { AddorUpdateRecord, getList, uploadResourceFile, updateResourceFile } from '../../redux/api/system'
import { Formik, Form } from 'formik'
import { useSnackbar } from 'notistack'
import { connect } from 'react-redux';
import { DataGrid } from '@mui/x-data-grid'
import TextInput from '../../components/common/TextInput';
import SelectInput from '../../components/common/SelectInput'
import { Add, Delete, Diversity2Outlined, Edit, Label } from '@mui/icons-material';
import PublicOffIcon from '@mui/icons-material/PublicOff';
import { dataTypeOptions } from '../../util';
import DocumentInput from '../../components/common/DocumentInput';
import CustomDataGrid from '../../components/CustomDataGrid';

const Resource = ({ user }) => {
    const [ showModal, setShowModal ] = useState(false)
    const [ selectedResource, setSelectedResource ] = useState({});
    const [ records, setRecords ] = useState([]);
    const [ resourceGroups, setResourceGroups ] = useState([]);
    const { enqueueSnackbar } = useSnackbar();
    const [ processing, setProcessing ] = useState(false)
    const [ mapAudience, setMapAudience ] = useState(false)
    const [ mapping, setMapping ] = useState(false);
    const [ institutions, setInstitutions ] = useState([]);
    const [ userData, setUserData ] = useState({});
    const [ deleteModal, setDeleteModal ] = useState(false);
    const [ isDeleting, setIsDeleting] = useState(false);

    const defaultResource =  {
        "resourceName": "",
        "resourceGroupID": "",
        "description": "",
        "url": "",
        "tags": "",
        "targetView": "",
        "resourceType": "",
        "isFRSCCResource": false
    };

    // console.log("User Data", user?.userData?.user_data?.institutionID);

    useEffect(() => {
        setUserData(user)
    }, [user])

    const columns = [
        { 
            field: 'sn', headerName: 'S/N', width: 100, sortable: false,
            renderCell: (params) => (
                <p
                    style={{ margin: 'auto' }}
                >
                    {params?.row?.sn}
                </p>
            )
        },
        {
            field: 'actions', headerName: 'Actions', width: 130, sortable: false,
            renderCell: (params) => (
                <div className='action-icons' style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', width: '100%', padding: '0 0.5rem' }}>
                    <IconButton
                        size='small'
                        color="primary"
                        variant="outlined" title='Edit Resource' className='p-0 m-0'
                        onClick={() => {
                            setSelectedResource(params?.row || defaultResource);
                            setShowModal(true)
                        }}
                    >
                        <Edit />
                    </IconButton>
                    
                    <IconButton
                        size='small'
                        color="primary"
                        variant="outlined" title='Set Consumers' className='p-0 m-0'
                        onClick={() => {
                            setSelectedResource(params?.row);
                            setMapAudience(true)
                        }}
                    >
                        <Diversity2Outlined />
                    </IconButton>

                    <IconButton
                        size='small'
                        color="error"
                        variant="outlined" title='Delete Resources' className='p-0 m-0'
                        onClick={() => {
                            setSelectedResource(params?.row);
                            setDeleteModal(true)
                        }}
                    >
                        <PublicOffIcon />
                    </IconButton>
                </div>
            )
        },
        { field: 'resourceName', headerName: 'Resource Name', width: 400 },
        { field: 'description', headerName: 'Description', width: 400 },
        { field: 'tags', headerName: 'Tags', width: 400 },
    ];

    const init = async () => {
        try {
            setProcessing(true)
            const resp = await getList("resources");
            const groupRes = await getList("resource_grps");
            const res = await getList("institutions");
            if(resp?.responseCode === "00") {
                setRecords(resp?.listing || [])
                setInstitutions(res?.listing || [])
            } else {
                enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
            }

            if(groupRes?.responseCode === "00") {
                setResourceGroups(groupRes?.listing || [])
            } else {
                enqueueSnackbar(groupRes?.message || groupRes?.responseMessage || 'An error occurred', { variant: 'error' })
            }
        }
        catch (err) {
            enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
        }
        finally {
            setProcessing(false);
        }
    }

    const createOrUpdateDomain = async (values, { resetForm }) => {
        try {

            let resourceObject = {...values};
            resourceObject.subMenus = null;
            //resourceObject.url = "";
            //resourceObject.targetView = "";
            resourceObject.roles = null;
            console.log("Resource Object", resourceObject);
            if(resourceObject?.resourceType == '3') {
                if(!resourceObject?.documentFileName) {
                    enqueueSnackbar('Please upload a data file', { variant: 'error' });
                    return;
                }

                const formData = new FormData();

                formData.append('file', resourceObject?.documentFileName ?? "");
                formData.append('resourceName', resourceObject?.resourceName ?? "");
                formData.append('resourceGroupID', resourceObject?.resourceGroupID ?? "");
                formData.append('tags', resourceObject?.tags ?? "");
                formData.append('resourceType', resourceObject?.resourceType ?? "");
                formData.append('IsFRSCCResource', resourceObject?.isFRSCCResource ?? false);
                formData.append('description', resourceObject?.description ?? "");
                formData.append('resourceID', resourceObject?.resourceID ?? "");
                formData.append('frequency', resourceObject?.frequency ?? "");
                
                const resp = resourceObject?.resourceID ? await updateResourceFile(formData) : await uploadResourceFile(formData);

                enqueueSnackbar(resp?.message || resp?.responseMessage || 'Request Successful', { variant: 'success' });
                init();
                
            }
            else {
                const resp = await AddorUpdateRecord("resource", resourceObject?.resourceID ? "update" : 'add', resourceObject);

                if(resp?.responseCode === "00") {
                    init();
                    setSelectedResource(defaultResource)
                    setShowModal(false)
                    enqueueSnackbar('Action performed successfully')
                } else {
                    enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
                }
            }

            setSelectedResource(defaultResource)
            setShowModal(false)
        }
        catch (err) {
            enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
        }
    };

    const deleteResource = async () => {
        try {
            setIsDeleting(true);

            const res = await AddorUpdateRecord("resource", "delete", selectedResource);

            if(res.responseCode === "00") {
                init();
                setSelectedResource(null);
                setDeleteModal(false);
                enqueueSnackbar('Role deleted successfully', { variant: 'success' });
            }
            else {
                enqueueSnackbar(res?.message ?? res?.responseMessage ?? 'An error occurred', { variant: 'error' })
            }
        }
        catch (err) {
            enqueueSnackbar(err?.message ?? err?.responseMessage ?? 'An error occurred', { variant: 'error' })
        }
        finally {
            setIsDeleting(false);
        }
    }

    const handleChange = (event, value) => {
        let newAudience = [ ...selectedResource?.audience ] || [];

        if(value) {
            if(event.target.name == "001") {
                newAudience = [ ...institutions?.map(({ id }) => ({ id }) ) ]
                
            } else {
                newAudience.push({ id: event.target.name });
            }
        } else {
            if(event.target.name == "001") {
                newAudience = []
            } else {
                newAudience = newAudience.filter(({ id }) => (id != event.target.name) && (id != "001"))
            }
        }
        setSelectedResource({ ...selectedResource, audience: newAudience })
    }

    const hasPrivilege = (id) => {
        return (selectedResource?.audience?.map(x => String(x?.id))?.indexOf(String(id)) >= 0) ? true : false
    }

    const handleMapping = async () => {
        try {
            setMapping(true)
            const resp = await AddorUpdateRecord("resource", "update", selectedResource);
            if(resp?.responseCode === "00") {
                init();
                setMapping(false);
                setSelectedResource(defaultResource)
                setMapAudience(false)
                enqueueSnackbar('Mapping successful')
            } else {
                enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
            }
        }
        catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', { variant: 'error' });
        }
        finally {
            setMapping(false)
        }
    };

    const types = [
        { id: '1', name: 'DataView' },
        { id: '2', name: 'DataSet' },
        { id: '3', name: 'PositionFile' },
        { id: '4', name: 'PowerBI' },
        { id: '5', name: 'ExternalUrl' },
    ]

    useEffect(() => {
        init()
    }, [])

    return (
        <PageContainer pageTitle='Resources' processing={processing}>
            <section className="inner-banner parallax-section">
                <div className='overlay'>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 col-sm-12">
                                <h3 className="wow bounceIn" data-wow-delay="0.9s">All</h3>
                                <h1 className="wow fadeInUp text-uppercase conference mb-05 mt-05" data-wow-delay="1.6s">Resources</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="services-area section-padding pt-3">
                <div className="container">
                    <div className="row">
                        <div className='col-12 text-align-right'>
                            <Button variant="contained" onClick={() => { setSelectedResource(defaultResource); setShowModal(true) }}>Create Resource</Button>
                        </div>
                        <div className='col-12 mt-4'>
                            <div style={{ height: 600, width: '100%', textAlign: 'center' }}>
                                <CustomDataGrid 
                                    columns={columns}
                                    rows={records}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          

            <Dialog open={showModal} maxWidth="md">
                <Formik 
                enableReinitialize 
                initialValues={selectedResource} 
                onSubmit={createOrUpdateDomain}
                >
                    {({ isSubmitting, values, setFieldValue }) => (
                        <Form>
                            <DialogContent className='pl-4 pr-4'>
                                <h3 className='text-bold mt-05' >{values?.resourceID ? 'Update' : 'Create'} Resource</h3>
                                <Divider className="mt-05 mb-2" />
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <TextInput id="resourceName" required label="Resource Name" />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextInput id="tags" label="Tag or Short code" />
                                    </Grid>
                                    <Grid item xs={12}>
                                        {/* <SelectInput field="id" label='OFI Category' fieldDisplay='id' id='ofi_category' options={ofis} />    */}
                                        <SelectInput field="id" required label='Resources Group' fieldDisplay='name' id='resourceGroupID'  options={resourceGroups} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextInput id="description" multiline minRows={2} required label="Resource Description" />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <SelectInput id="resourceType" label="Resource Type" value={values?.resourceType ? types.find(({ id }) => String(id) == String(values?.resourceType)).name : ''}  fieldDisplay='name' field="id" required
                                            options={[
                                                { id: '1', name: 'DataView' },
                                                { id: '2', name: 'DataSet' },
                                                { id: '3', name: 'PositionFile' },
                                                { id: '4', name: 'PowerBI' },
                                                { id: '5', name: 'ExternalUrl' },
                                            ]}
                                        />
                                    </Grid>
                                    {
                                        (values?.resourceType == '1' || values?.resourceType == '2') &&
                                        <Grid item xs={12}>
                                            <SelectInput id="target" label="Target"
                                                field="id" required
                                                fieldDisplay={ values?.resourceType == '1' ? "dataViewName" : "dataSetName" }
                                                selectFunction={async () => {
                                                    const resp = await getList(values?.resourceType == '1' ? 'dataset_views' : 'datasets')
                                                    return resp?.listing || []
                                                }}
                                            />
                                        </Grid>
                                    }
                                    {
                                        (values?.resourceType == '5' || values?.resourceType == '4') &&
                                        <Grid item xs={12}>
                                            <TextInput id="url" label="Resource URL" required />
                                        </Grid>
                                    }
                                    {
                                        (values?.resourceType == '3') &&
                                        <>
                                            <Grid item xs={12}>
                                                <DocumentInput 
                                                    id="documentFileName" 
                                                    label="Upload Data File" 
                                                    placeholder="Click to upload Data File" 
                                                    required 
                                                    // value={values?.documentFileName}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <SelectInput 
                                                    required 
                                                    id="frequency" 
                                                    label="Resource Frequency" 
                                                    options={[{ code: 'yearly' }, { code: 'quarterly' }, { code: 'monthly' }, { code: 'daily' }, { code: "bi-annually" }]} 
                                                    fieldDisplay="code" 
                                                    field="code"
                                                />
                                            </Grid>
                                        </>
                                    }
                                </Grid>
                                <Grid item xs={12}>
                                    {
                                        user?.userData?.user_data?.isFSRCCMember &&
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={values.isFRSCCResource} />
                                            }
                                            label={<b className='f-15'>Add to FSRCC Resources</b>}
                                            name={"isFRSCCResource"}
                                            onChange={() => setFieldValue('isFRSCCResource', !values.isFRSCCResource)}
                                        />
                                    }
                                </Grid>
                                
                            </DialogContent>
                            <DialogActions className='pr-3 pb-3'>
                                <Button disabled={isSubmitting} onClick={() => { if(!isSubmitting) { setShowModal(false); setSelectedResource(defaultResource) }}} color="secondary" variant="contained" >Cancel</Button>
                                <Button type='submit' variant="contained" disabled={isSubmitting} >
                                    {
                                        isSubmitting ?
                                        <CircularProgress size={15} color="inherit" />
                                        :
                                        values?.resourceID ? 'Update Resource' : 'Add Resource'
                                    }
                                </Button>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </Dialog>


            <Dialog open={mapAudience} maxWidth='lg'>
                <DialogTitle className='no-margin m-0 pt-2' style={{ textTransform: 'initial' }}>
                    <h4 className='m-0'>Map Resource to Institutions: <b>{selectedResource?.dataSetName}</b></h4>
                </DialogTitle>
                <DialogContent style={{ height: '500px', width: '600px', padding: '0 2rem' }}>
                    <FormControl component="fieldset" variant="standard">
                        <FormGroup>
                            {
                                institutions.map((institution, key) => (
                                    <FormControlLabel
                                        control={
                                            <Checkbox checked={hasPrivilege(institution.id)} onChange={handleChange} name={institution.id} />
                                        }
                                        label={institution.institutionName} key={key}
                                    />
                                ))
                            }
                        </FormGroup>
                    </FormControl>
                </DialogContent>
                <DialogActions style={{ padding: '1rem' }}>
                    <Button onClick={() => { setMapAudience(false); setSelectedResource(defaultResource) }} color='secondary' variant='contained'>Cancel</Button>

                    <Button onClick={handleMapping} color='primary' variant='contained'>
                        { mapping ? <CircularProgress size={15} color='inherit' /> : 'Save Mapping' }
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={deleteModal} maxWidth="lg">
                <DialogContent className='pl-4 pr-4'>
                    <p className='text-bold mt-05' style={{ fontSize: "1.2em" }} >Are you sure you want to <b style={{ color: "red" }}>delete the Resource</b> from the system</p>
                    <Divider className="mt-2" />
                </DialogContent>
                <DialogActions className='pr-3 pb-3'>
                    <Button 
                        disabled={isDeleting} 
                        onClick={() => { 
                            if(!isDeleting) { 
                                setDeleteModal(false); 
                                setSelectedResource(null) 
                            }}} 
                        color="secondary" 
                        variant="contained" >
                            Cancel
                        </Button>
                    <Button variant="contained" disabled={isDeleting} onClick={deleteResource} >
                        {
                            isDeleting ?
                            <CircularProgress size={15} color="inherit" />
                            :
                            'Delete Resource'
                        }
                    </Button>
                </DialogActions>
            </Dialog>
        </PageContainer>
    )
}

export default connect(({ user }) => ({ user }))(Resource)